import type { ContextMenuItemConfig } from '@milanote/roma';
import { getElementId } from '../../../../common/elements/utils/elementPropertyUtils';
import type { ElementContextMenuContext } from '../context/elementContextMenuContext';
import { ELEMENT_CORE_CONTEXT_MENU_ITEMS } from './elementCoreContextMenuItems';
import { ELEMENT_LAYOUT_CONTEXT_MENU_ITEMS } from './elementLayoutContextMenuItems';
import { ELEMENT_MEDIA_CONTEXT_MENU_ITEMS } from './elementMediaContextMenuItems';
import { SelectedElementDetailsMenuItem } from './selectedElementDetailsMenuItem';

/** Produces one debug menu row per selected element when debug mode is enabled. */
export const getSelectedElementDetailItems = (
    context: ElementContextMenuContext,
): ContextMenuItemConfig<ElementContextMenuContext>[] => {
    if (!context.permissions.showDevTools) return [];

    return context.selectedElements.toArray().map((element) => {
        const elementId = getElementId(element);
        return {
            type: 'custom',
            id: elementId,
            label: () => elementId,
            component: SelectedElementDetailsMenuItem,
            onAction: (context) => context.actions.logSelectedElement(element),
        };
    });
};

export const ELEMENT_CONTEXT_MENU_ITEMS = {
    ...ELEMENT_CORE_CONTEXT_MENU_ITEMS,
    ...ELEMENT_MEDIA_CONTEXT_MENU_ITEMS,
    ...ELEMENT_LAYOUT_CONTEXT_MENU_ITEMS,
};
